import { T } from 'gt-react';
import type { PpvReceiveAt } from '@erp/shared-types';

export function ReceiveCostLabel({
  basis,
  cost,
}: {
  basis: PpvReceiveAt | null;
  cost: string | null;
}) {
  switch (basis) {
    case 'po_cost':
      return <T context="receiving valuation basis">PO cost</T>;
    case 'buyer_cost':
      return <T context="receiving valuation basis">Buyer cost</T>;
    case 'cost_constraint':
      return (
        <span>
          <T context="receiving valuation basis between system and PO costs">
            Cost constraint cost
          </T>
          <span className="block tabular-nums">{cost ?? '—'}</span>
        </span>
      );
    default:
      return <>—</>;
  }
}
